module.exports = __webpack_public_path__ + "static/universis-students-d97f7199799996c548591cf6cb7f2dac.png";